package ui.app.assign.detail.kindergarten.preview

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import api.AppType
import compose.assets.Svg
import compose.assets.svg.Package_down
import compose.assets.svg.Package_up
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_bottom_detail__action_move_from_archive_to_active
import ssoft.frontend.generated.resources.layer_bottom_detail__action_move_to_archive
import tk.mallumo.compose.navigation.ComposableNavNode
import tk.mallumo.utils.DataState
import tools.rememberString
import ui.app.assign.detail.AppDeleteDialog
import ui.app.assign.detail.AppDetailArgs
import ui.app.assign.detail.kindergarten.KindergartenSummary
import ui.app.assign.typeName
import ui.widget.*

@ComposableNavNode(AppDetailArgs::class)
@Composable
fun AppKindergartenPreviewUI() {
    with(AppKindergartenPreviewScope.rememberScope()) {
        when (val state = vm.state) {
            is DataState.Error -> ErrUI()
            is DataState.Idle,
            is DataState.Loading -> LoadingUI()

            is DataState.Result -> Content(state.nnvl)
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun AppKindergartenPreviewScope.Content(nnvl: AppKindergartenPreviewScope.Wrapper) {
    val deleteDialogState = DialogState.remember()

    AppDeleteDialog(deleteDialogState, AppType.KINDERGARTEN) { deleteLogo: Boolean, deleteContent: Boolean ->
        action(AppKindergartenPreviewVM.Action.Delete(deleteLogo, deleteContent))
    }

    val toolbarActions = remember {
        buildList {
            if (nnvl.canDelete) {
                add(ToolbarAction.delete {
                    deleteDialogState.show()
                })
            }
            if (nnvl.canEdit) {
                if (nnvl.data.archived) {
                    add(ToolbarAction(Svg.Package_up, tooltip = Res.string.layer_bottom_detail__action_move_from_archive_to_active) {
                        action(AppKindergartenPreviewVM.Action.Archive(false))
                    })
                } else {
                    add(ToolbarAction(Svg.Package_down, tooltip = Res.string.layer_bottom_detail__action_move_to_archive) {
                        action(AppKindergartenPreviewVM.Action.Archive(true))
                    })
                }
                add(ToolbarAction.edit {
                    action(AppKindergartenPreviewVM.Action.Edit)
                })
            }
        }
    }
    Column(Modifier.fillMaxSize()) {
        Toolbar(
            nav = nav,
            titlePrefix = AppType.KINDERGARTEN.typeName().rememberString(),
            titleSuffix = "(${nnvl.data.id})",
            actions = toolbarActions
        )
        KindergartenSummary(nnvl.data, true)
    }
}
